<template>
  <div>
    <transition name="slide-right" v-show="visible">
      <div class="sidebar_drawer" :class="[
        'tw-grid tw-grid-rows-[auto_1fr_auto] tw-fixed tw-inset-0 tw-bg-white border',
      ]">
        <header class="tw-flex tw-justify-between tw-items-center tw-min-h-[84px] tw-border-b tw-border-blue-dark-50 tw-text-blue-dark-500 tw-p-6" v-if="headerTitle">
          <div>
            <base-icon :icon="headerIcon" class="fs-21 tw-align-middle tw-ml-3"></base-icon>
            <h3 v-text="headerTitle" class="tw-inline-block !tw-font-bold tw-text-small tw-mb-0"></h3>
          </div>
          <base-icon icon="close" class="c-pointer fs-21" @click="close"></base-icon>
        </header>

        <!--    Body    -->
        <div class="tw-overflow-hidden tw-py-6 tw-px-5">
          <slot name="body" />
        </div>

        <footer class="tw-flex tw-flex-wrap tw-gap-[12px] tw-p-6 tw-pb-5 tw-justify-end tw-min-h-[84px] tw-items-center tw-border-t tw-border-blue-dark-50"
                :class="footerClass">
          <slot name="footer" />
        </footer>
      </div>
    </transition>
  </div>
</template>

<script setup>
import {computed, ref, watch, getCurrentInstance} from 'vue'
import BaseIcon from "@/components/base/BaseIcon.vue";

const { proxy } = getCurrentInstance();
const showMoreDetail = ref(false);
const zIndex = ref(null)

const props = defineProps({
  visible: { type: Boolean, default: false },
  headerTitle: { type: String, default: null },
  headerIcon: { type: String, default: 'info-bold' },
  footerClass: { type: String, default: '' },
})

const emit = defineEmits(['update:visible', 'close'])

const close = () => {
  emit('update:visible', false)
  emit('close', true)
}
</script>

<style >

.sidebar_drawer {
  width: var(--sidebar-width);
  z-index: 1031;
}
.right-sidebar {
  border-radius: 0.75rem 0 0 0.75rem;
  box-shadow: -8px 0px 40px rgba(176, 212, 250, 0.35);
}

.btn-close {
  background: transparent;
  border: none;
  font-size: 18px;
  cursor: pointer;
}

/* انیمیشن باز و بسته شدن */
.slide-right-enter-active,
.slide-right-leave-active {
  transition: transform 0.3s ease, opacity 0.1s ease;
}

.slide-right-enter-from,
.slide-right-leave-to {
  transform: translateX(100%);
  opacity: 0;
}
</style>
